let light = '#fff';
const grey = '#d7dfe1';
let dark = '#000';
const disabledColor = '#ccc';
const backgroundColor = '#fff';

let primaryColor = '#083845';
let primaryColorLight = '#d7dfe1';
let secondaryColor = '#00669d';
let tercaryColor = '#000';
let bodyColor = '#083845';
let titleColor = null;
let menuColor = null;
let textShadowColor = '#333';
switch (process.env.REACT_APP_SITE) {
  case 'hemato':
    primaryColor = '#4f0700';
    primaryColorLight = 'rgba(79, 7, 0, 0.2)';
    secondaryColor = '#c00d0d';
    tercaryColor = '#000';
    titleColor = '#fff';
    bodyColor = '#4f0700';
    break;
  case 'neuro':
    primaryColor = '#083845';
    primaryColorLight = '#d7dfe1';
    secondaryColor = '#00669d';
    tercaryColor = '#000';
    titleColor = '#fff';
    bodyColor = '#083845';
    break;
  case 'dermato':
  case 'dermato_rs':
    primaryColor = '#5c2a34';
    primaryColorLight = 'rgba(92, 43, 52, 0.2)';
    secondaryColor = '#db663f';
    tercaryColor = '#000';
    bodyColor = '#5c2a34';
    titleColor = primaryColor;
    bodyColor = '#5c2a34';
    menuColor = '#000';
    textShadowColor = '#ccc';
    // dark = '#fff';
    // light = primaryColor;
    // textShadowColor = 'transparent';

    break;
  default:
}
export {
  light,
  grey,
  dark,
  disabledColor,
  backgroundColor,
  primaryColor,
  primaryColorLight,
  secondaryColor,
  tercaryColor,
  bodyColor,
  titleColor,
  menuColor,
  textShadowColor,
};



// WEBPACK FOOTER //
// ./src/helpers/colors.js